import React, { useEffect, useRef, useState } from "react";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Sort,
  Resize,
  Edit,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import { GetAllMisc, AddMisc, EditMisc, DeleteMisc } from "../../api";
import { Header } from "../../components";
import "../../styles/viewCustomer.css";
import { Col, Container, Row } from "react-bootstrap";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import SelectFilter from "../../components/SelectFilter";

const Misc = () => {
  const gridRef = useRef(null);
  const [Data, setData] = useState("");
  const [option, setOption] = useState({
    label: "Category",
    api: "category",
    value: "catg",
  });
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(false);

  const fieldOptions = [
    { label: "Category", api: "category", value: "catg" },
    { label: "Sales Category", api: "salescategory", value: "sctg" },
    { label: "Unit", api: "unit", value: "unit" },
    { label: "Transaction Type", api: "transactiontype", value: "ttyp" },
    { label: "Physical Location", api: "physicallocation", value: "ploc" },
    { label: "PN Status", api: "pnstatus", value: "pnst" },
    { label: "SO Status", api: "sostatus", value: "sost" },
    { label: "Terms", api: "term", value: "term" },
    { label: "Ship Method", api: "shipmethod", value: "smtd" },
    { label: "Payment Status", api: "paymentstatus", value: "pyst" },
    { label: "PO Status", api: "postatus", value: "post" },
    { label: "Operator/Technician", api: "employee", value: "oper" },
    { label: "Testing OS", api: "gpuwb/testos", value: "ttos" },
    { label: "Testing App", api: "gpuwb/testapp", value: "ttap" },
    { label: "Station ID", api: "gpuwb/teststation", value: "stid" },
  ];

  const colGrid = [
    {
      headerText: "ID",
      field: Data.length > 0 ? Object.keys(Data[0])[0] : "id",
      isPrimaryKey: true,
      visible: false,
    },
    {
      headerText: option.label,
      field: "name",
      textAlign: "center",
    },
  ];

  const actionBegin = async (args) => {
    if (args.requestType === "save" && option.api && args.data.name) {
      setloading(true);
      try {
        if (args.action === "add") {
          const resp = await AddMisc(option.api, args.data.name);
          if (resp.success)
            showSuccessToast("Success!", `${option.label} added successfully!`);
          else
            showErrorToast(
              "Error!",
              `${option.label} failed to add!\n\n` + resp.message,
            );
        } else if (args.action === "edit") {
          const resp = await EditMisc(
            option.api,
            args.data[Object.keys(Data[0])[0]],
            args.data.name,
          );
          if (resp.success)
            showSuccessToast(
              "Success!",
              `${option.label} updated successfully!`,
            );
          else
            showErrorToast(
              "Error!",
              `${option.label} failed to update!\n\n` + resp.message,
            );
        }
      } catch (err) {
        showErrorToast("Error!", `${option.label} did not update!`);
      } finally {
        setloading(false);
      }
      updateData();
    } else if (
      args.requestType === "delete" &&
      option.api &&
      args.data.length > 0 &&
      args.data[0][Object.keys(Data[0])[0]]
    ) {
      setloading(true);
      try {
        const resp = await DeleteMisc(
          option.api,
          args.data[0][Object.keys(Data[0])[0]],
        );
        if (resp.success)
          showSuccessToast("Success!", `${option.label} deleted successfully!`);
        else
          showErrorToast(
            "Error!",
            `${option.label} failed to delete!\n\n` + resp.message,
          );
      } catch (err) {
        showErrorToast("Error!", `${option.label} did not delete!`);
      } finally {
        setloading(false);
      }
      updateData();
    }
  };

  const handleChangeOption = (option) => {
    TimeoutUtility.resetTimeout();
    if (option && option.value) setOption(option);
    else setOption("select");
  };

  const updateData = async () => {
    if (option && option.api) {
      setloading(true);
      trackPromise(
        GetAllMisc(option.api)
          .then((resp) => setData(resp.data))
          .catch((error) => console.error("Error fetching data:", error))
          .finally(() => setloading(false)),
      );
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (option && option.api) {
        setloading(true);
        trackPromise(
          GetAllMisc(option.api)
            .then((resp) => setData(resp.data))
            .catch((error) => console.error("Error fetching data:", error))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [option]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Row>
        <Col xl={2} md={3}>
          <Header category="Admin" title="MISCELLANEOUS" />
        </Col>
        <Col xl={8} md={6} className="text-center pt-4">
          <Header title={option.label} />
        </Col>
      </Row>
      <Container fluid className="g-0 p-0 justify-end">
        <Row xs={2} className="button-row justify-content-end font-normal">
          <Col md="auto p-0 mb-8">
            <SelectFilter
              value={option}
              options={fieldOptions}
              onChange={handleChangeOption}
              placeholder="Select Option"
              isClearable={false}
            />
          </Col>
        </Row>
        <Row xs={2} className="button-row justify-content-center font-normal">
          <Col md={10} lg={8} xl={6}>
            {loading || promiseInProgress ? (
              <LoadingIndicator />
            ) : (
              <GridComponent
                className="custom-grid"
                dataSource={Data}
                ref={gridRef}
                height="calc(62vh - 60px)"
                allowPaging={true}
                pageSettings={{ pageSize: 16, pageSizes: [16, 32, 64, 100] }}
                allowSorting
                allowResizing
                editSettings={{
                  allowEditing: true,
                  allowAdding: true,
                  allowDeleting: true,
                }}
                actionBegin={actionBegin}
                toolbar={[
                  "Add",
                  "Edit",
                  "Delete",
                  "Update",
                  "Cancel",
                  "Search",
                ]}
                rowHeight={36}
              >
                <ColumnsDirective>
                  {colGrid.map((item, index) => (
                    <ColumnDirective
                      key={index}
                      {...item}
                      validationRules={{ required: true }}
                    />
                  ))}
                </ColumnsDirective>
                <Inject services={[Resize, Page, Edit, Toolbar, Sort]} />
              </GridComponent>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Misc;
